export default __webpack_public_path__ + "static/media/search.992ec4ee.svg";